export const FILTER_ALL = "todos";

export const MOTIVO_OPTIONS = [
  "Manutenção corretiva",
  "Inspeção extraordinária",
  "Troca de componentes de AMV",
  "Bloqueio emergencial",
  "Janela operacional",
];

export const TIPO_INTERDICAO_OPTIONS = ["TO", "LOCOMOTIVAS", "VAGÕES", "VIA"];

export const TIPO_OPERACAO_OPTIONS = [
  "Manobra",
  "Circulação",
  "Transferência",
  "Pátio",
];

export const POSTO_ORIGEM_SOS_OPTIONS = ["CCO", "Pátio", "Oficina", "Terminal", "Campo"];

export const NIVEL_ACIONAMENTO_OPTIONS = [
  "N1 - LÍDER / SOS",
  "N2 - COORDENADOR / ESPECIALISTA",
  "N3 - GERENTE",
  "N4 - GERENTE EXECUTIVO",
];

export function pad2(value) {
  return String(value).padStart(2, "0");
}

function getSaoPauloDateParts(date = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/Sao_Paulo",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(date);

    return parts.reduce((acc, part) => {
      if (part.type !== "literal") acc[part.type] = part.value;
      return acc;
    }, {});
  } catch {
    return {
      year: String(date.getFullYear()),
      month: pad2(date.getMonth() + 1),
      day: pad2(date.getDate()),
      hour: pad2(date.getHours()),
      minute: pad2(date.getMinutes()),
    };
  }
}

export function toTodayYMD() {
  const parts = getSaoPauloDateParts();
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function toCurrentHHMM() {
  const parts = getSaoPauloDateParts();
  return `${parts.hour}:${parts.minute}`;
}

export function parseYMD(value) {
  if (!value || typeof value !== "string") return null;
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day, 12, 0, 0);
}

export function toYMD(date) {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function toBRDate(value) {
  const date = parseYMD(value);
  if (!date) return "";
  return new Intl.DateTimeFormat("pt-BR").format(date);
}

export function normalizeText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

export function makeInitialInterdicaoForm() {
  return {
    tipoInterdicao: "VIA",
    viaData: toTodayYMD(),
    viaHorarioInicio: toCurrentHHMM(),
    sb: "",
    kmInicial: "",
    motivo: "",
    observacao: "",
    sub: "",
    identificador: "",
    acionamento: "",
    nivelAcionamento: "",
    temPrevisao: "nao",
    dataFim: "",
    horaFim: "",
    toData: toTodayYMD(),
    toHorarioInicio: toCurrentHHMM(),
    toSb: "",
    toKm: "",
    toAtivo: "",
    toAcionamento: "",
    toNivelAcionamento: "",
    toMotivo: "",
    toObservacao: "",
    toTemLiberacao: "nao",
    toDataLiberacao: "",
    toHorarioLiberacao: "",
    locomotivasData: toTodayYMD(),
    locomotivasHorarioInicio: toCurrentHHMM(),
    locomotivasTrem: "",
    locomotivasSbParada: "",
    locomotivasKm: "",
    locomotivasNumeroAtivo: "",
    locomotivasFrota: "",
    locomotivasTipoOperacao: "",
    locomotivasPostoOrigemSos: "",
    locomotivasMecanicoAcionado: "",
    locomotivasNivelAcionamento: "",
    locomotivasMotivo: "",
    locomotivasObservacao: "",
    locomotivasTemLiberacao: "nao",
    locomotivasDataLiberacao: "",
    locomotivasHorarioLiberacao: "",
    vagoesData: toTodayYMD(),
    vagoesHorarioInicio: toCurrentHHMM(),
    vagoesTrem: "",
    vagoesSbParada: "",
    vagoesKm: "",
    vagoesNumeroAtivo: "",
    vagoesFrota: "",
    vagoesTipoOperacao: "",
    vagoesPostoOrigemSos: "",
    vagoesMecanicoAcionado: "",
    vagoesNivelAcionamento: "",
    vagoesMotivo: "",
    vagoesObservacao: "",
    vagoesTemLiberacao: "nao",
    vagoesDataLiberacao: "",
    vagoesHorarioLiberacao: "",
  };
}
